import { render, staticRenderFns } from "./BirthdateMissingDialog.vue?vue&type=template&id=0aa439f8&scoped=true"
import script from "./BirthdateMissingDialog.vue?vue&type=script&lang=js"
export * from "./BirthdateMissingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa439f8",
  null
  
)

export default component.exports